/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import dayjs from 'dayjs';

import {
  Card,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import _ from 'lodash';
import * as actions from '../../redux/actions';
import { OrderForm, AddProductForm } from '../../components/Forms';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';

const defaultValues = {
  type_code: '',
  name: '',
  description: '',
};

const CreateOrder = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customer);
  const me = useSelector((state) => state.me);
  const product = useSelector((state) => state.product);
  const productType = useSelector((state) => state.productType);
  const employee = useSelector((state) => state.employee);
  const warehouse = useSelector((state) => state.warehouse);

  const history = useHistory();
  const [reload, setReload] = useState(false);
  const [productList, setProductList] = useState([]);
  const [barcodeInput, setBarcodeInput] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [selectSerial, setSelectSerial] = useState([]);
  const [selectWarehouse, setSelectWarehouse] = useState(null);
  const [selectOption, setSelectOption] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const [uploadedImage, setUploadedImage] = useState('');

  // Setting React hook form
  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
    reset,
  } = useForm();

  const [name] = useState('');
  const [page] = useState(1);
  const [size] = useState(5);
  const [type, setType] = useState(null);
  const [filterProduct, setFilterProduct] = useState(null);
  const [defaultMe, setDefaultMe] = useState(me?.userData);



  useEffect(() => {
    dispatch(actions.productAllWithLightWeight(''));
    dispatch(actions.warehouseAll(''));
    dispatch(actions.employeeAll(''));
    dispatch(actions.productTypeAll(''));
    dispatch(actions.customerAll(''));
    dispatch(actions.meGet());
    setDefaultMe(me?.userData);

    return () => { };
  }, [name, page, size]);

  // useEffect(() => {
  //   setProductList([]);

  //   return () => {};
  // }, [selectWarehouse]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const AddManyProductModal = ({ open, onClose, productList, setProductList }) => {
    const [barcodeInput, setBarcodeInput] = useState('');

    const handleScan = (e) => {
      if (e.key === 'Enter') {
        const product = mockProducts.find((p) => p.type_code === barcodeInput.trim());

        if (product) {
          const existingIndex = productList.findIndex(
            (item) => item.product._id === product._id
          );

          if (existingIndex !== -1) {
            const updated = [...productList];
            updated[existingIndex].amount += 1;
            setProductList(updated);
          } else {
            setProductList([
              ...productList,
              {
                product,
                amount: 1,
                project_number: '',
                warehouse: {}, // กำหนดภายหลัง
              },
            ]);
          }
        } else {
          alert('ไม่พบสินค้านี้ในระบบ');
        }

        setBarcodeInput('');
      }
    };

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>เพิ่มรายการสินค้าด้วยบาร์โค้ด</DialogTitle>
        <DialogContent>
          <TextField
            label="ยิงบาร์โค้ดสินค้า"
            fullWidth
            autoFocus
            value={barcodeInput}
            onChange={(e) => setBarcodeInput(e.target.value)}
            onKeyDown={handleScan}
          />
          <ul className="mt-4 list-disc ml-4">
            {productList.map((p, idx) => (
              <li key={idx}>
                {p.product.name} - จำนวน: {p.amount}
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined">ปิด</Button>
        </DialogActions>
      </Dialog>
    );
  };



  const onSubmit = async (data, event) => {
    // ตรวจสอบว่าปุ่มที่กดคือ Enter หรือไม่
    if (event.key === 'Enter') {
      event.preventDefault(); // ป้องกันการ submit ของฟอร์ม
      // คุณสามารถทำสิ่งอื่นๆ ที่นี่ถ้าจำเป็น
      return;
    }

    if (!data.warehouse) {
      alert('กรุณาระบุคลังสินค้าก่อน');
    } else {
      // eslint-disable-next-line no-lonely-if
      if (productList?.length === 0) {
        alert('กรุณาเพิ่มสินค้าก่อน');
      } else {
        setCreateLoading(true);
        try {
          const preprocessedData = {
            ...data,
            order_type: 'IMPORT',
            import_employee: {
              ...defaultMe,
              // eslint-disable-next-line no-underscore-dangle
              _id: defaultMe?._id,
            },
            real_import_employee: data.employee || null,
            import_date:
              data.date || dayjs(new Date()).locale('th').format('YYYY-MM-DD'),
            orders: _.map(productList, (each) => ({
              // eslint-disable-next-line no-underscore-dangle
              product: each.product._id,
              amount: each.amount,
              serialNumber: each?.serialNumber,
              warehouse: each.warehouse._id,
              project_number: each.project_number,
            })),
            modify_employee: me?.userData?._id,

            images: _.map(uploadedImage, (image) => ({
              image: image.data_url,
            })),
            warehouse: null,
          };
          event.preventDefault();
          await dispatch(actions.productTransactionCreate(preprocessedData));
          reset(defaultValues);
          setUploadedImage('');
          await dispatch(actions.productTransactionAll({ name, page, size }));
          setCreateLoading(false);
          alert('สำเร็จ');
          history.goBack();
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
  const handleAddmanyProduct = () => {
    setOpenModal(true);
  };

  const handleDeleteProduct = (index) => {
    productList.splice(index, 1);
    setProductList(productList);
    setReload(!reload);
  };

  const renderForm = () => (
    <Card className="p-6">
      <div className="py-2">เพิ่มข้อมูล</div>
      <OrderForm
        Controller={Controller}
        control={control}
        errors={errors}
        watch={watch}
        customers={customer.rows}
        product={product.rows}
        productType={productType.rows}
        employees={employee.rows}
        warehouse={warehouse.rows}
        type={type}
        setType={setType}
        filterProduct={filterProduct}
        setFilterProduct={setFilterProduct}
        me={me}
        uploadedImage={uploadedImage}
        setUploadedImage={setUploadedImage}
        setSelectWarehouse={setSelectWarehouse}
      />
    </Card>
  );

  const renderAddProductForm = () => (
    <Card className="p-6">
      <div className='flex justify-between items-center'>
        <div className="py-2">เพิ่มสินค้า</div>
        {/* <div>
          <Button variant="contained" onClick={handleAddmanyProduct}>เพิ่มหลายรายการ</Button>
        </div> */}
      </div>
      <AddManyProductModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        productList={productList}
        setProductList={setProductList}
      />
      <AddProductForm
        Controller={Controller}
        control={control}
        errors={errors}
        product={product.rows}
        type={type}
        setType={setType}
        filterProduct={filterProduct}
        setFilterProduct={setFilterProduct}
        productList={productList}
        setProductList={setProductList}
        reload={reload}
        setReload={setReload}
        selectSerial={selectSerial}
        setSelectSerial={setSelectSerial}
        setSelectOption={setSelectOption}
        selectOption={selectOption}
        selectWarehouse={selectWarehouse}
      />
    </Card>
  );

  const displayProduct = () => (
    <TableContainer>
      <Table size="small" className="border-lg">
        <TableHead className="bg-yellow-100">
          <TableRow>
            <TableCell>
              <div className="font-bold">ลำดับที่</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> คลังสินค้า / หมายเลขโครงการ</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> ชื่อสินค้า</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> จำนวน</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> ดำเนินการ</div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!_.isEmpty(productList) ? (
            productList.map((_product, index) => (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                className={index % 2 === 0 ? 'bg-gray-100' : ''}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  {_product?.warehouse.name} / {_product?.project_number}
                </TableCell>
                <TableCell>{_product?.product.name} ({_product?.serialNumber})</TableCell>
                <TableCell>{_product?.amount}</TableCell>
                <TableCell>
                  <Button
                    color={'error'}
                    variant="contained"
                    size={'small'}
                    onClick={() => handleDeleteProduct(index)}
                  >
                    ลบ
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow key={''}>
              <TableCell colSpan={6}>
                <div className="text-center">ไม่มีรายการ</div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderShowProductList = () => (
    <Card className="p-6">
      <div className="py-2">รายการสินค้า</div> {displayProduct()}
    </Card>
  );

  if (
    customer.isLoading ||
    product.isLoading ||
    employee.isLoading ||
    createLoading
  ) {
    return <Loading />;
  }
  if (
    !product.isLoading &&
    product.isCompleted &&
    !customer.isLoading &&
    customer.isCompleted &&
    !employee.isLoading &&
    employee.isCompleted &&
    !createLoading
  ) {
    return (
      <div>
        <div className="flex justify-between">
          <div>{renderTitle()}</div>
        </div>
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">สร้างการนำเข้าสินค้า</div>
        </div>
        <form>
          <div className="md:flex">
            <div className="w-full md:w-1/3 pr-4">{renderForm()}</div>
            <div className="w-full md:w-2/3 pt-4 md:pt-0">
              {renderAddProductForm()}
              <div className="w-full pt-4">{renderShowProductList()}</div>
            </div>
          </div>
          <div className="flex flex-row justify-end gap-1 py-4">
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={handleSubmit(onSubmit)}
            >
              บันทึก
            </Button>
          </div>
        </form>
      </div>
    );
  }
  return <Error message={customer?.message} />;
};

CreateOrder.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateOrder.defaultProps = {
  title: '',
  subtitle: '',
};

export default CreateOrder;
